import { render, staticRenderFns } from "./RedefenirSenha.vue?vue&type=template&id=1cfd3339&scoped=true&"
import script from "./RedefenirSenha.vue?vue&type=script&lang=js&"
export * from "./RedefenirSenha.vue?vue&type=script&lang=js&"
import style0 from "./RedefenirSenha.vue?vue&type=style&index=0&id=1cfd3339&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cfd3339",
  null
  
)

export default component.exports